export default __webpack_public_path__ + "static/media/business_operational_staff.9b27c6a8.svg";